import moment from "moment";

const CUTOFF_DISPLAY_FORMAT = "DD-MM-YYYY";

// FECHA_CORTE can arrive as an ISO instant or in the original display format.
export const formatCollectionCutoffDate = (value?: string | null): string => {
  if (!value) return "-";
  const iso = moment(value, moment.ISO_8601, true);
  if (iso.isValid()) return iso.utc().format(CUTOFF_DISPLAY_FORMAT);
  const displayed = moment(value, CUTOFF_DISPLAY_FORMAT, true);
  return displayed.isValid() ? displayed.format(CUTOFF_DISPLAY_FORMAT) : "-";
};
